import {
  Box,
  BoxProps,
  Center,
  Flex,
  FlexProps,
  HStack,
  Heading,
  HeadingProps,
  Spinner,
} from '@masterplandev/ui'

export function CompanyPage(props: { blockScroll?: boolean } & BoxProps) {
  const { blockScroll = false, ...rest } = props

  const scrollStyle: BoxProps = blockScroll
    ? {
        overflowY: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }
    : {
        overflowY: 'scroll',
      }

  return (
    <Box
      bg="mpBackgroundLight"
      flex="1"
      minW="0"
      layerStyle="scroll"
      overflowX="auto"
      {...scrollStyle}
      sx={{
        '@media print': {
          overflow: 'visible',
        },
      }}
      {...rest}
    />
  )
}

export function CompanyPageHeader(props: FlexProps) {
  return <Flex gap="6" align="flex-end" {...props} />
}

export function CompanyPageHeading(props: HeadingProps) {
  return <Heading size="h3" {...props} />
}

export function CompanyPageCounter({
  value,
  label,
}: {
  value: number
  label: string
}) {
  return (
    <HStack align="baseline" gap={2}>
      <Box
        fontSize="md"
        lineHeight="20px"
        fontWeight={700}
        data-testid="company-page-counter-value">
        {value}
      </Box>
      <Box
        textStyle="subhead"
        color="mp2.neutralLight.600"
        data-testid="company-page-counter-label">
        {label}
      </Box>
    </HStack>
  )
}

export function CompanyPageLoading() {
  return (
    <CompanyPage>
      <Center h="sm">
        <Spinner size="xl" />
      </Center>
    </CompanyPage>
  )
}
